// @ts-nocheck
// Cart-side prescription RX flow (V2). Mirrors V1 functionality.

console.log('[prescription-rx] script loaded');

// Inject inline CSS so back-button visibility is driven by which step
// container is currently visible — independent of any data-attribute or
// class-based state racing in JS.
(function injectRxStyles() {
  if (document.getElementById('prescription-rx-inline-styles')) return;
  const style = document.createElement('style');
  style.id = 'prescription-rx-inline-styles';
  style.textContent = `
    .prescription-modal-back-btn {
      display: none !important;
    }
    .prescription-rx-modal:has(.input-prescription-values-container:not(.hidden)) .prescription-modal-back-btn,
    .prescription-rx-modal:has(.your-prescription-container:not(.hidden)) .prescription-modal-back-btn,
    .prescription-rx-modal:has(.add-prescription-container:not(.hidden)) .prescription-modal-back-btn,
    .prescription-rx-modal:has(.prescription-type-container:not(.hidden)) .prescription-modal-back-btn,
    .prescription-rx-modal:has(.after-booking-container:not(.hidden)) .prescription-modal-back-btn {
      display: inline-flex !important;
      align-items: center;
      visibility: visible;
      background: transparent;
      border: 0;
      padding: 0;
      cursor: pointer;
    }
    .prescription-modal-back-btn svg {
      width: 24px;
      height: 24px;
      display: block;
    }
    /* Header: back stays left, close stays right — works whether back is visible or not.
       margin-left:auto on close pushes it to the right edge regardless of siblings. */
    .prescription-modal-icon-wrap {
      display: flex !important;
      align-items: center;
      justify-content: flex-start !important;
    }
    .prescription-modal-close-btn {
      margin-left: auto !important;
    }
  `;
  document.head.appendChild(style);
})();

// Vanilla pre-binder so the trigger works before jQuery finishes loading
(function preBindRxTrigger() {
  function openModal() {
    const modal = document.querySelector('.prescription-rx-modal');
    console.log('[prescription-rx] openModal called, modal:', modal);
    if (!modal) return;
    modal.classList.remove('hidden');
    // Force visible regardless of cached CSS / stale snippet
    modal.style.cssText =
      'position:fixed;inset:0;z-index:2147483647;display:block;opacity:1;visibility:visible;pointer-events:auto;';
    const bg = modal.querySelector('.modal-bg');
    if (bg) {
      bg.classList.remove('opacity-0');
      bg.classList.add('opacity-100');
      bg.style.cssText =
        'position:fixed;inset:0;background:rgba(107,114,128,0.75);opacity:1;z-index:1;';
    }
    const fixedScroll = modal.querySelector('.fixed.inset-0.overflow-y-auto, .modal-scroll');
    if (fixedScroll) {
      fixedScroll.style.cssText =
        'position:fixed;inset:0;overflow-y:auto;z-index:2;display:block;';
    }
    const flexInner = modal.querySelector('.flex.items-end, .modal-scroll-inner');
    if (flexInner) {
      flexInner.style.cssText =
        'display:block;width:100%;min-height:100vh;text-align:left;';
    }
    const isDesktopOpen = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
    const container = modal.querySelector('.modal-container');
    if (container) {
      container.classList.remove('opacity-0', 'translate-y-4');
      container.classList.add('opacity-100', 'translate-y-0');
      if (isDesktopOpen) {
        // Desktop: viewport-locked, no inner scroll
        container.style.cssText =
          'position:fixed;inset:0;opacity:1;background:#fff;width:100vw;height:100vh;display:block;overflow:hidden;';
      } else {
        // Mobile: natural document height — let .modal-scroll handle scrolling
        container.style.cssText =
          'position:relative;opacity:1;background:#fff;width:100%;min-height:100vh;display:block;';
      }
    }
    const stepWrap = modal.querySelector('.build-rx-step-wrap, .prescription-rx-step-wrap');
    if (stepWrap) {
      stepWrap.style.cssText =
        'display:flex;flex-direction:row;width:100%;height:100vh;';
    }
    // Left image pane (covers stale + new markup)
    const left =
      modal.querySelector('.prescription-rx-modal__left') ||
      (stepWrap && stepWrap.children[0]);
    if (left) {
      left.classList.remove('hidden');
      left.style.cssText =
        'display:flex;width:54%;height:100vh;background:#F2F4F7;align-items:center;justify-content:center;flex-shrink:0;padding:0;';
    }
    // Right pane: flex column, body scrolls, footer button(s) stick to bottom
    const right =
      modal.querySelector('.prescription-rx-modal__right') ||
      (stepWrap && stepWrap.children[stepWrap.children.length - 1]);
    if (right && right !== left) {
      right.style.cssText =
        'flex:1;height:100vh;background:#fff;display:flex;flex-direction:column;overflow:hidden;position:relative;';
      const headerWrap = right.querySelector('.prescription-modal-icon-wrap');
      if (headerWrap) headerWrap.style.flexShrink = '0';
      // Body wrapper = scrollable region. NOTE: keep position:static so the
      // absolute footer (Checkout/Continue) anchors to .right (viewport pane),
      // not to the scrolling body's content height.
      const body = right.querySelector('.prescription-rx-modal__body, .md\\:pb-10');
      if (body) {
        body.style.flex = '1 1 auto';
        body.style.overflowY = 'auto';
        body.style.minHeight = '0';
        body.style.position = 'static';
        // No padding on mobile; desktop padding is handled by the media query in CSS
        body.style.padding = '';
      }
      // Kill inner scroll containers that would trap layout
      right
        .querySelectorAll(
          '.input-prescription-values-container > div, ' +
            '.your-prescription-wrap, ' +
            '.confirm-prescription-wrap, ' +
            '.edit-prescription-values-container, ' +
            '.input-prescription-values-wrap, ' +
            '.eye-prescription-values-wrap'
        )
        .forEach((el) => {
          el.style.maxHeight = 'none';
          el.style.overflow = 'visible';
        });
      // Strip any positioning context on intermediate containers so the absolute
      // footer anchors all the way up to .right (the viewport pane).
      [
        '.your-prescription-container',
        '.your-prescription-wrap',
        '.input-prescription-values-container',
        '.input-prescription-values-wrap',
        '.input-validation-form',
      ].forEach((sel) => {
        right.querySelectorAll(sel).forEach((el) => {
          el.style.position = 'static';
        });
      });

      // Pin Continue + Checkout button wrappers. On desktop they're absolute
      // (anchored to .right viewport pane). On mobile we keep them in normal flow
      // so the page scrolls naturally as one column.
      const isDesktop = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
      const footerStyle = (el) => {
        if (isDesktop) {
          el.style.position = 'absolute';
          el.style.bottom = '0';
          el.style.left = '0';
          el.style.right = '0';
        } else {
          el.style.position = 'sticky';
          el.style.bottom = '0';
        }
        el.style.zIndex = '10';
        el.style.background = '#fff';
        el.style.borderTop = '1px solid #EDEFF399';
        el.style.boxShadow = '0px -1px 10px 0px #EDEFF3B2';
        el.style.padding = '16px';
        el.style.display = 'flex';
        el.style.justifyContent = 'center';
        el.style.margin = '0';
      };
      right
        .querySelectorAll('.input-validation-form > div:last-child')
        .forEach((wrap) => {
          if (wrap.querySelector('.continue-prescription-btn[data-btn-role="input"]')) {
            footerStyle(wrap);
          }
        });
      const checkoutWrap = right.querySelector('#continue-payment-btn');
      if (checkoutWrap && checkoutWrap.parentElement) footerStyle(checkoutWrap.parentElement);

      // Reserve space at the bottom of the scrollable body equal to whichever
      // footer is currently visible, so the form's last fields aren't hidden.
      // Mobile: footer is sticky in flow, no padding needed.
      const updateBodyPadding = () => {
        if (!body) return;
        const isMobile = window.matchMedia && !window.matchMedia('(min-width: 768px)').matches;
        if (isMobile) {
          body.style.paddingBottom = '';
          return;
        }
        // Desktop: find the visible footer wrapper (absolute or otherwise) so we
        // can reserve scroll-space equal to its rendered height.
        const candidates = Array.from(
          right.querySelectorAll('.input-validation-form > div:last-child, #continue-payment-btn')
        ).map((el) => (el.id === 'continue-payment-btn' ? el.parentElement : el));
        const visibleFooter = candidates.find((el) => {
          if (!el) return false;
          const cs = getComputedStyle(el);
          return cs.display !== 'none' && el.offsetParent !== null;
        });
        const h = visibleFooter ? visibleFooter.getBoundingClientRect().height : 0;
        body.style.paddingBottom = h ? h + 24 + 'px' : '96px';
      };
      updateBodyPadding();
      // Re-measure after layout settles + on resize
      requestAnimationFrame(updateBodyPadding);
      window.removeEventListener('resize', updateBodyPadding);
      window.addEventListener('resize', updateBodyPadding);
      // Expose so other handlers can re-measure (e.g. opening edit form)
      modal._updateBodyPadding = updateBodyPadding;
    }
    // Force the cart-item image inside the left pane to be visible
    if (left) {
      const isMobile = window.matchMedia && !window.matchMedia('(min-width: 768px)').matches;
      left.querySelectorAll('.cart-item-image-wrap').forEach((wrap, i) => {
        // Apply identical layout to ALL wraps. Visibility is controlled by the
        // .hidden class (CSS rule has !important so it beats this inline).
        wrap.style.cssText = isMobile
          ? 'display:flex;flex-direction:column;align-items:flex-start;gap:17px;'
          : 'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:24px;';
        if (i === 0) {
          wrap.classList.remove('hidden');
          wrap.classList.add('selected');
        } else {
          wrap.classList.add('hidden');
          wrap.classList.remove('selected');
        }
        wrap.querySelectorAll('img').forEach((img) => {
          img.classList.remove('hidden');
          img.style.cssText = isMobile
            ? 'width:100%;height:auto;aspect-ratio:613/300;object-fit:cover;mix-blend-mode:darken;display:block;'
            : 'width:100%;max-width:560px;height:auto;aspect-ratio:613/300;object-fit:contain;mix-blend-mode:darken;display:block;';
        });
        wrap.querySelectorAll('p').forEach((p) => {
          p.style.cssText = isMobile
            ? 'font-size:16px;line-height:1.25;text-align:left;color:#000;margin:0;'
            : 'font-size:24px;line-height:1.2;text-align:center;color:#000;margin:0;';
        });
      });
    }
    // Mobile: stack left pane above right pane (matches build-rx-modal pattern)
    if (window.matchMedia && !window.matchMedia('(min-width: 768px)').matches) {
      if (left) {
        left.style.display = 'flex';
        left.style.width = '100%';
        left.style.height = 'auto';
        left.style.padding = '55px 25px 16px 16px';
      }
      if (right) {
        right.style.width = '100%';
        right.style.height = 'auto';
        right.style.flex = '1';
      }
      if (stepWrap) {
        stepWrap.style.flexDirection = 'column';
        stepWrap.style.height = 'auto';
        stepWrap.style.minHeight = '100vh';
      }
    }
    // Header icons: ensure both buttons are sized & visible when meant to be
    modal.querySelectorAll('.prescription-modal-icon-wrap button').forEach((btn) => {
      btn.style.background = 'transparent';
      btn.style.border = '0';
      btn.style.padding = '0';
      btn.style.cursor = 'pointer';
      const svg = btn.querySelector('svg');
      if (svg) {
        svg.style.width = '24px';
        svg.style.height = '24px';
        svg.style.display = 'block';
      }
    });
    const iconWrap = modal.querySelector('.prescription-modal-icon-wrap');
    if (iconWrap) {
      iconWrap.style.padding = '22px 24px';
      iconWrap.style.display = 'flex';
      iconWrap.style.alignItems = 'center';
      // justify-content + close-btn pinning are handled in injected CSS
      iconWrap.style.justifyContent = '';
    }
    document.documentElement.style.overflow = 'hidden';
  }
  document.addEventListener('click', function (e) {
    const target = e.target.closest && e.target.closest('.triggerRX, [data-rx-trigger]');
    if (!target) return;
    console.log('[prescription-rx] trigger clicked');
    e.preventDefault();
    e.stopPropagation();
    openModal();
  }, true);

  // Booking iframe modal
  document.addEventListener('click', function (e) {
    const opener = e.target.closest && e.target.closest('#book-appointment-container, .book-appointment-option');
    if (opener) {
      e.preventDefault();
      e.stopPropagation();
      const m = document.getElementById('booking-iframe-modal');
      if (m) {
        const iframe = m.querySelector('iframe[data-src]');
        if (iframe && !iframe.src) {
          iframe.src = iframe.dataset.src;
        }
        m.classList.remove('hidden');
        m.style.display = 'block';
        document.documentElement.style.overflow = 'hidden';
      }
      return;
    }
    const closer = e.target.closest && e.target.closest('#close-booking-modal');
    if (closer) {
      const m = document.getElementById('booking-iframe-modal');
      if (m) {
        m.classList.add('hidden');
        m.style.display = 'none';
      }
      document.documentElement.style.overflow = '';
      return;
    }
    if (e.target && e.target.id === 'booking-iframe-modal') {
      e.target.classList.add('hidden');
      e.target.style.display = 'none';
      document.documentElement.style.overflow = '';
    }
  }, true);
})();

(function waitForJQuery() {
  if (typeof jQuery !== 'undefined') return initPrescriptionRx();
  let tries = 0;
  const interval = setInterval(() => {
    tries++;
    if (typeof jQuery !== 'undefined') {
      clearInterval(interval);
      initPrescriptionRx();
    } else if (tries > 200) {
      clearInterval(interval);
    }
  }, 100);
})();

function initPrescriptionRx() {
  // Singleton — prevent multiple bindings if script is re-executed
  // (Shopify section morphing / hot reload).
  if (window.__prescriptionRxBound) return;
  window.__prescriptionRxBound = true;

  const $ = jQuery;
  if (!document.querySelector('.prescription-rx-modal')) return;

  const RX_RANGES = {
    sphere: [3, -8],
    cylinder: [3, -3],
    power: [3, -10],
    pd: [37, 27],
    add: [3, 0.75],
  };

  function makeId(length) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let r = '';
    for (let i = 0; i < length; i++) r += chars.charAt(Math.floor(Math.random() * chars.length));
    return r;
  }

  function showEl($el) { $el.removeClass('hidden'); }
  function hideEl($el) { $el.addClass('hidden'); }

  function validateRX(prefix) {
    const isProgressive = !!$('.eye-prescription-values-wrap.progressive').length
      || ($('.input-prescription-values-wrap[data-prescription-type="single"]').find('.rx-add-field').not('.hidden').length > 0);

    const rightSphere = parseFloat($(`#${prefix}right-sphere`).val());
    const rightCylinder = parseFloat($(`#${prefix}right-cylinder`).val());
    const rightAxis = parseFloat($(`#${prefix}right-axis`).val());
    const rightAdd = parseFloat($(`#${prefix}right-add`).val());
    const totalRightPower = rightSphere + rightCylinder;

    const leftSphere = parseFloat($(`#${prefix}left-sphere`).val());
    const leftCylinder = parseFloat($(`#${prefix}left-cylinder`).val());
    const leftAxis = parseFloat($(`#${prefix}left-axis`).val());
    const leftAdd = parseFloat($(`#${prefix}left-add`).val());
    const totalLeftPower = leftSphere + leftCylinder;

    const errors = [];
    const checkRange = (value, range, label) => {
      if (value > range[0] || value < range[1] || isNaN(value)) {
        errors.push(`${label} is out of range (${range[1]} to ${range[0]})`);
      }
    };

    checkRange(leftSphere, RX_RANGES.sphere, 'Left Sphere');
    checkRange(leftCylinder, RX_RANGES.cylinder, 'Left Cylinder');
    if (leftAxis > 180 || leftAxis < 0 || isNaN(leftAxis)) errors.push('Left Axis is out of range (0 to 180)');
    checkRange(totalLeftPower, RX_RANGES.power, 'Left Total Power');

    checkRange(rightSphere, RX_RANGES.sphere, 'Right Sphere');
    checkRange(rightCylinder, RX_RANGES.cylinder, 'Right Cylinder');
    if (rightAxis > 180 || rightAxis < 0 || isNaN(rightAxis)) errors.push('Right Axis is out of range (0 to 180)');
    checkRange(totalRightPower, RX_RANGES.power, 'Right Total Power');

    if (isProgressive) {
      checkRange(rightAdd, RX_RANGES.add, 'Right Add');
      checkRange(leftAdd, RX_RANGES.add, 'Left Add');
    }
    return errors.length ? 'error' : 'success';
  }

  function showModal() {
    const modal = document.querySelector('.prescription-rx-modal');
    if (modal) {
      modal.classList.remove('hidden');
      modal.style.cssText =
        'position:fixed;inset:0;z-index:2147483647;display:block;opacity:1;visibility:visible;pointer-events:auto;';
    }
    document.documentElement.style.overflow = 'hidden';
  }
  function hideModal() {
    const modal = document.querySelector('.prescription-rx-modal');
    if (modal) {
      modal.classList.add('hidden');
      modal.style.display = 'none';
    }
    document.documentElement.style.overflow = '';
  }

  function syncSingleRxFormToCurrentItem() {
    const $current = $('.cart-item-image-wrap.selected').not('.hidden');
    if (!$current.length) return;
    const isProgressive = $current.attr('data-is-progressive') === 'true';
    const $singleWraps = $(
      '.input-prescription-values-wrap[data-prescription-type="single"], .your-prescription-wrap[data-prescription-type="single"]'
    );
    const $addFields = $singleWraps.find('.rx-add-field');
    const $addSummaries = $singleWraps.find('.rx-add-summary');
    if (isProgressive) { $addFields.removeClass('hidden'); $addSummaries.show(); }
    else { $addFields.addClass('hidden'); $addSummaries.hide(); }
  }

  // ----- modal open/close -----
  $(document).on('click', '.triggerRX, [data-rx-trigger]', function (e) {
    e.preventDefault();
    showModal();
  });
  $(document).on('click', '.prescription-modal-close-btn', function () { hideModal(); });
  $(document).on('click', '.prescription-rx-modal .modal-bg', function (e) {
    if (e.target === this) hideModal();
  });

  // ----- step navigation -----
  // Back logic derived from what's visible — no integer state to corrupt.
  // Forward chain (1 RX item):     upload → input-values → your-prescription
  // Forward chain (2+ RX items):   upload → prescription-type → (input-values OR add-prescription) → your-prescription
  $(document).on('click', '.prescription-modal-back-btn', function () {
    const isVisible = (sel) => {
      const el = document.querySelector(sel);
      return el && !el.classList.contains('hidden');
    };
    const totalRx =
      parseInt(
        document.querySelector('.cart-items-container')?.getAttribute('data-cart-items-count') ||
          document.querySelector('.input-prescription-value-option')?.getAttribute('data-cart-items-count') ||
          '1',
        10
      ) || 1;
    const isMulti = totalRx > 1;

    // Determine current step container, hide it, then show its predecessor.
    if (isVisible('.your-prescription-container')) {
      hideEl($('.your-prescription-container'));
      showEl($('.input-prescription-values-container'));
    } else if (isVisible('.input-prescription-values-container')) {
      hideEl($('.input-prescription-values-container'));
      if (isMulti) {
        showEl($('.prescription-type-container'));
      } else {
        showEl($('.upload-prescription-container'));
      }
    } else if (isVisible('.add-prescription-container')) {
      hideEl($('.add-prescription-container'));
      showEl($('.prescription-type-container'));
    } else if (isVisible('.prescription-type-container')) {
      hideEl($('.prescription-type-container'));
      showEl($('.upload-prescription-container'));
    } else if (isVisible('.after-booking-container')) {
      hideEl($('.after-booking-container'));
      showEl($('.upload-prescription-container'));
    }
    // CSS :has() rule auto-hides the back button when only the upload step is visible.
  });

  // Centralised: set the active step. data-current-step is informational only —
  // back-button visibility & header layout are entirely CSS-driven via :has().
  function setStep(step) {
    $('.prescription-modal-back-btn')
      .attr('data-current-step', step)
      .removeClass('hidden');
    bumpBodyPadding();
  }

  // Re-measure scrollable body's bottom-padding so the absolute Continue/Checkout
  // footer never covers the last form fields. Runs after each step transition.
  function bumpBodyPadding() {
    const m = document.querySelector('.prescription-rx-modal');
    if (m && typeof m._updateBodyPadding === 'function') {
      requestAnimationFrame(() => {
        m._updateBodyPadding();
        // Run again on the next frame in case footer height was still settling
        requestAnimationFrame(m._updateBodyPadding);
      });
    }
  }

  $(document).on('keydown', '.input-prescription-value-option, .prescription-type-wrap, .single-prescription-type, .multiple-prescription-type', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      $(this).click();
    }
  });

  // step 1 → 2/4: choose enter manually
  $(document).on('click', '.input-prescription-value-option', function () {
    const $self = $(this);
    const currentStep = parseInt($('.prescription-modal-back-btn').attr('data-current-step'), 10) || 1;
    const nextStep = currentStep + 1;
    const totalCartItems = parseInt($self.attr('data-cart-items-count'), 10);
    console.log('[prescription-rx] enter-manually click; currentStep=', currentStep, 'nextStep=', nextStep);

    hideEl($('.upload-prescription-container'));

    if (totalCartItems <= 1) {
      const $c = $('.input-prescription-values-container');
      showEl($c).attr('data-rx-step', nextStep);
      showEl($('.input-prescription-values-wrap[data-prescription-type="single"]'));
    } else {
      const $c = $('.prescription-type-container');
      showEl($c).attr('data-rx-step', nextStep);
    }
    // Direct update first (defensive — independent of setStep closure)
    document.querySelectorAll('.prescription-modal-back-btn').forEach((b) => {
      b.setAttribute('data-current-step', String(nextStep));
      b.classList.remove('hidden');
    });
    setStep(nextStep);
    console.log('[prescription-rx] data-current-step now=', $('.prescription-modal-back-btn').attr('data-current-step'));
  });

  // step 2 → 3
  $(document).on('click', '.prescription-type-wrap', function () {
    const selectedType = $(this).attr('data-prescription-type-wrap');
    const currentStep = parseInt($('.prescription-modal-back-btn').attr('data-current-step'), 10) || 1;

    hideEl($('.prescription-type-container'));

    if (selectedType === 'single') {
      // Show input form container with the single wrap unhidden
      $('.input-prescription-values-container')
        .removeClass('hidden')
        .css('display', 'block')
        .attr('data-rx-step', currentStep + 1);
      $('.input-prescription-values-wrap').addClass('hidden').css('display', '');
      $('.input-prescription-values-wrap[data-prescription-type="single"]')
        .removeClass('hidden')
        .css('display', 'block');
      syncSingleRxFormToCurrentItem();
    } else {
      // Show add-prescription-container with the multiple wrap unhidden
      $('.add-prescription-container')
        .removeClass('hidden')
        .css('display', 'block')
        .attr('data-rx-step', currentStep + 1);
      $('.add-prescription-wrap').addClass('hidden').css('display', '');
      $('.add-prescription-wrap[data-prescription-type="multiple"]')
        .removeClass('hidden')
        .css('display', 'block');
      // Prepare the multi-input wrap for when the user drills into a specific item
      $('.input-prescription-values-wrap').addClass('hidden').css('display', '');
      $('.input-prescription-values-wrap[data-prescription-type="multiple"]')
        .removeClass('hidden')
        .css('display', 'block');
    }

    // Mirror the type onto the final review wrap & checkout payload
    hideEl($('.your-prescription-wrap'));
    showEl($(`.your-prescription-wrap[data-prescription-type="${selectedType}"]`));
    $('#continue-payment-btn').attr('data-prescription-type', selectedType);

    setStep(currentStep + 1);
  });

  // expand/collapse multi
  $(document).on('click', '.add-prescription-type-drop-down-btn', function () {
    const $btn = $(this);
    $btn.toggleClass('rotate-180');
    const cartItemNo = $btn.attr('data-cart-item-no');
    const $wrap = $(`.multiple-prescription-type-wrap[data-cart-item-no="${cartItemNo}"]`);
    $wrap.toggleClass('hidden');
  });

  $(document).on('click', '.single-prescription-type', function () {
    const currentStep = parseInt($('.prescription-modal-back-btn').attr('data-current-step'), 10) || 1;
    setStep(currentStep + 1);
    hideEl($('.add-prescription-container'));
    showEl($('.input-prescription-values-container'));
  });

  $(document).on('click', '.multiple-prescription-type', function () {
    const cartItemNo = $(this).closest('.multiple-prescription-type-wrap').attr('data-cart-item-no');
    const currentStep = parseInt($('.prescription-modal-back-btn').attr('data-current-step'), 10) || 2;
    console.log('[prescription-rx] drill into multi item', cartItemNo, 'currentStep:', currentStep);

    hideEl($('.add-prescription-container'));
    // Force input-prescription-values-container visible
    $('.input-prescription-values-container').removeClass('hidden').css('display', 'block')
      .attr('data-rx-step', currentStep + 1);

    // Clear any previously-set inline display:none on wraps & force the multi wrap visible
    $('.input-prescription-values-wrap').addClass('hidden').css('display', '');
    $('.input-prescription-values-wrap[data-prescription-type="multiple"]')
      .removeClass('hidden')
      .css('display', 'block');

    // Hide all per-item forms, then force-show only the selected one
    $('.eye-prescription-values-wrap').addClass('hidden').css('display', '');
    $(`.eye-prescription-values-wrap[data-cart-item-no="${cartItemNo}"]`)
      .removeClass('hidden')
      .css('display', 'block');

    setStep(currentStep + 1);
    console.log(
      '[prescription-rx] post drill: container hidden?', $('.input-prescription-values-container').hasClass('hidden'),
      '| multi wrap hidden?', $('.input-prescription-values-wrap[data-prescription-type="multiple"]').hasClass('hidden'),
      '| eye wrap hidden?', $(`.eye-prescription-values-wrap[data-cart-item-no="${cartItemNo}"]`).hasClass('hidden')
    );
  });

  // PD toggle
  $(document).on('click', '.pd-toggle-btn', function () {
    const $btn = $(this);
    const cartItemNo = $btn.attr('data-cart-item-no');
    $(`.pd-toggle-btn[data-cart-item-no="${cartItemNo}"]`).toggleClass('toggled');
    // a11y: keep role="switch" state in sync (WCAG 4.1.2)
    $(`.pd-toggle-btn[data-cart-item-no="${cartItemNo}"]`).attr('aria-checked', $btn.hasClass('toggled') ? 'true' : 'false');
    const $pdWrap = $(`.pd-eye-wrap[data-cart-item-no="${cartItemNo}"]`);
    if ($btn.hasClass('toggled')) {
      $pdWrap.find('.pd-add-one-value').addClass('hidden');
      $pdWrap.find('.pd-add-two-values').removeClass('hidden').css('display', 'flex');
      $(`.pd-one-value[data-cart-item-no="${cartItemNo}"]`).addClass('hidden');
      $(`.pd-two-value[data-cart-item-no="${cartItemNo}"]`).removeClass('hidden').css('display', 'flex');
    } else {
      $pdWrap.find('.pd-add-one-value').removeClass('hidden');
      $pdWrap.find('.pd-add-two-values').addClass('hidden');
      $(`.pd-one-value[data-cart-item-no="${cartItemNo}"]`).removeClass('hidden');
      $(`.pd-two-value[data-cart-item-no="${cartItemNo}"]`).addClass('hidden');
    }
  });

  // a11y: keyboard activation for the PD role="switch" (WCAG 2.1.1)
  $(document).on('keydown', '.pd-toggle-btn', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      $(this).click();
    }
  });

  // carousel between cart items
  $(document).on('click', '.prev-cart-item-select-btn', function () {
    const $btn = $(this);
    let prevNo = parseInt($btn.attr('data-prev-cart-item-no'), 10);
    if (prevNo <= 0) return;

    $('.cart-item-image-wrap').addClass('hidden').removeClass('selected');
    $(`.cart-item-image-wrap[data-cart-item-no="${prevNo}"]`).removeClass('hidden').addClass('selected');

    hideEl($(`.eye-prescription-values-wrap[data-cart-item-no="${prevNo + 1}"]`));
    showEl($(`.eye-prescription-values-wrap[data-cart-item-no="${prevNo}"]`));

    syncSingleRxFormToCurrentItem();
    prevNo--;
    $btn.attr('data-prev-cart-item-no', prevNo);
    $('.next-cart-item-select-btn').attr('data-next-cart-item-no', prevNo + 2).prop('disabled', false);
    if (prevNo === 0) $btn.prop('disabled', true);
  });

  $(document).on('click', '.next-cart-item-select-btn', function () {
    const $btn = $(this);
    const total = parseInt($('.cart-items-container').attr('data-cart-items-count'), 10);
    let nextNo = parseInt($btn.attr('data-next-cart-item-no'), 10);
    if (nextNo > total) return;

    $('.cart-item-image-wrap').addClass('hidden').removeClass('selected');
    $(`.cart-item-image-wrap[data-cart-item-no="${nextNo}"]`).removeClass('hidden').addClass('selected');

    hideEl($(`.eye-prescription-values-wrap[data-cart-item-no="${nextNo - 1}"]`));
    showEl($(`.eye-prescription-values-wrap[data-cart-item-no="${nextNo}"]`));

    syncSingleRxFormToCurrentItem();
    nextNo++;
    $btn.attr('data-next-cart-item-no', nextNo);
    $('.prev-cart-item-select-btn').attr('data-prev-cart-item-no', nextNo - 2).prop('disabled', false);
    if (nextNo === total + 1) $btn.prop('disabled', true);
  });

  // edit / remove
  $(document).on('click', '.your-prescription-drop-down-btn', function () {
    const $btn = $(this);
    $btn.toggleClass('rotate-180');
    const cartItemNo = $btn.attr('data-cart-item-no');
    $(`.confirm-prescription-wrap[data-cart-item-no="${cartItemNo}"]`).toggleClass('hidden');
  });

  $(document).on('click', '.edit-prescription-btn', function () {
    const cartItemNo = $(this).closest('.confirm-prescription-wrap').attr('data-cart-item-no');
    const $c = $(`.edit-prescription-values-container[data-cart-item-no="${cartItemNo}"]`);
    $c.removeClass('hidden max-h-0').addClass('mt-8');
    $c.css({ display: 'block', 'max-height': 'none', overflow: 'visible', 'margin-top': '32px' });
    // Remove inherited scroll on the prescription-wrap so the form has room
    $('.your-prescription-wrap').css({ 'max-height': 'none', overflow: 'visible' });
    $('.confirm-prescription-wrap').css({ 'max-height': 'none', overflow: 'visible' });
    // Re-measure body padding so the absolute footer doesn't cover the new form's bottom
    const modal = document.querySelector('.prescription-rx-modal');
    if (modal && typeof modal._updateBodyPadding === 'function') {
      requestAnimationFrame(modal._updateBodyPadding);
    }
    // Scroll the body so the user sees the start of the form
    const body = document.querySelector('.prescription-rx-modal__body, .md\\:pb-10');
    if (body) {
      const target = $c[0];
      if (target) {
        body.scrollTo({ top: target.offsetTop - 80, behavior: 'smooth' });
      }
    }
  });

  $(document).on('click', '.remove-prescription-btn', function () {
    const cartItemNo = $(this).closest('.confirm-prescription-wrap').attr('data-cart-item-no');
    hideEl($(`.added-prescription-values-wrap[data-cart-item-no="${cartItemNo}"]`));
    $(`.edit-validation-form[data-cart-item-no="${cartItemNo}"]`).attr('data-removed', 'true');
  });

  // mirror selects to summary + edit form
  $(document).on('change', '.input-validation-form select', function () {
    const $sel = $(this);
    const value = $sel.val();
    const valueType = $sel.attr('data-value-type');
    $(`.confirm-prescription-wrap .${valueType}`).text(value);
    $(`.edit-validation-form select[data-value-type="${valueType}"]`).val(value);
  });
  $(document).on('change', '.edit-validation-form select', function () {
    const $sel = $(this);
    const value = $sel.val();
    const valueType = $sel.attr('data-value-type');
    $(`.confirm-prescription-wrap .${valueType}`).text(value);
  });

  function toggleContinueGradient($form, on) {
    const cartItemNo = $form.attr('data-cart-item-no');
    const $btn = $form.find(`.continue-prescription-btn[data-cart-item-no="${cartItemNo}"]`);
    if (on) {
      $btn.removeClass('bg-[#DEE2E9] text-[#6F7176B2]')
        .addClass('bg-gradient-to-r from-[#023DA8] to-[#024ED6] text-white')
        .css({ background: 'linear-gradient(90deg, #023DA8 0%, #024ED6 100%)', color: '#fff' });
    } else {
      $btn.removeClass('bg-gradient-to-r from-[#023DA8] to-[#024ED6] text-white')
        .addClass('bg-[#DEE2E9] text-[#6F7176B2]')
        .css({ background: '#DEE2E9', color: 'rgba(111,113,118,0.7)' });
    }
  }
  $(document).on('change', '.input-confirm-rx', function () {
    toggleContinueGradient($(this).closest('.input-validation-form'), $(this).is(':checked'));
  });
  $(document).on('change', '.edit-confirm-rx', function () {
    toggleContinueGradient($(this).closest('.edit-validation-form'), $(this).is(':checked'));
  });

  // continue
  $(document).on('click', '.continue-prescription-btn', function () {
    const $self = $(this);
    const $wrap = $self.closest('.input-prescription-values-wrap');
    const prescriptionType = $wrap.attr('data-prescription-type') || 'single';
    const btnRole = $self.attr('data-btn-role');
    const cartItemsCount = parseInt($self.attr('data-cart-items-count'), 10) || 1;
    const currentCartItemNo = prescriptionType === 'single' ? cartItemsCount : parseInt($self.attr('data-cart-item-no'), 10);
    const prefix = prescriptionType === 'single' ? `${btnRole}-0-` : `${btnRole}-${currentCartItemNo}-`;

    const $form = $self.closest('form');
    $form.find('p.error').remove();

    if (validateRX(prefix) !== 'success') {
      $form.append('<p class="error">Unfortunately we are unable to fulfill your prescription. Please visit our <a target="_blank" href="/pages/frequentlyaskedquestions">FAQ Page</a> for more info.</p>');
      return;
    }
    if (!$form[0].checkValidity()) { $form[0].reportValidity(); return; }

    if (btnRole === 'input') {
      if (prescriptionType !== 'single' && currentCartItemNo < cartItemsCount) {
        hideEl($self.closest('.eye-prescription-values-wrap'));
        showEl($(`.eye-prescription-values-wrap[data-cart-item-no="${currentCartItemNo + 1}"]`));

        $('.cart-item-image-wrap').addClass('hidden').removeClass('selected');
        $(`.cart-item-image-wrap[data-cart-item-no="${currentCartItemNo + 1}"]`).removeClass('hidden').addClass('selected');

        $('.prev-cart-item-select-btn').attr('data-prev-cart-item-no', currentCartItemNo).prop('disabled', false);
        $('.next-cart-item-select-btn').attr('data-next-cart-item-no', currentCartItemNo + 2);
        if (currentCartItemNo + 2 > cartItemsCount) $('.next-cart-item-select-btn').prop('disabled', true);
      } else {
        const currentStep = parseInt($('.prescription-modal-back-btn').attr('data-current-step'), 10) || 1;
        $('.your-prescription-container').attr('data-rx-step', currentStep + 1);
        hideEl($('.input-prescription-values-container'));
        showEl($('.your-prescription-container'));
        setStep(currentStep + 1);
      }
    } else {
      const itemKey = prescriptionType === 'single' ? '0' : currentCartItemNo;
      showEl($(`.added-prescription-values-wrap[data-cart-item-no="${itemKey}"]`));
      $(`.edit-validation-form[data-cart-item-no="${itemKey}"]`).attr('data-removed', 'false');
      hideEl($self.closest('.edit-prescription-values-container'));
    }
  });

  // checkout
  function attachLineProperties(updates) {
    if (!updates.length) { window.location.href = '/checkout'; return; }
    const next = updates.shift();
    $.ajax({
      type: 'POST', url: '/cart/change.js', data: next, dataType: 'json',
      success: () => attachLineProperties(updates),
      error: () => attachLineProperties(updates),
    });
  }
  function buildPDIfNeeded($form) {
    const $toggle = $form.find('.pd-toggle-btn');
    if (!$toggle.hasClass('toggled')) {
      const combined = parseFloat($form.find('.pd-combined__self').val());
      if (Number.isFinite(combined)) {
        const half = (Math.round((combined * 100) / 2) / 100).toString();
        $form.find('.left-pd').val(half);
        $form.find('.right-pd').val(half);
      }
    }
  }

  $(document).on('click', '#continue-payment-btn', async function (e) {
    e.preventDefault();
    const $btn = $(this);
    $btn.prop('disabled', true).css('cursor', 'not-allowed');
    const prescriptionType = $btn.attr('data-prescription-type');

    try {
      if (prescriptionType === 'single') {
        const $form = $('.your-prescription-wrap[data-prescription-type="single"] form.edit-validation-form');
        if ($form.attr('data-removed') === 'true') { window.location.href = '/checkout'; return; }
        const referenceName = 'TY-' + makeId(9);
        $form.find('.reference-name-rx').val(referenceName);
        buildPDIfNeeded($form);
        await $.ajax({ type: 'POST', url: 'https://api.blenderseyewear.com/addRx', data: $form.serialize() });
        const cart = await $.getJSON('/cart.js');
        const updates = (cart.items || [])
          .filter((item) => item.sku && item.sku.includes('RX'))
          .map((item) => ({ id: item.key, properties: { __prescriptionFile: referenceName, __prescriptionType: 'Self' } }));
        attachLineProperties(updates);
      } else {
        const submitForms = $('.your-prescription-wrap[data-prescription-type="multiple"] form.edit-validation-form');
        let processed = 0, succeeded = 0;
        const total = submitForms.length;

        for (const formEl of submitForms.toArray()) {
          processed++;
          const $form = $(formEl);
          if ($form.attr('data-removed') === 'true') { succeeded++; continue; }
          const cartItemId = $form.attr('data-cart-item-id');
          const referenceName = 'TY-' + makeId(9);
          $form.find('.reference-name-rx').val(referenceName);
          buildPDIfNeeded($form);
          try {
            await $.ajax({ type: 'POST', url: 'https://api.blenderseyewear.com/addRx', data: $form.serialize() });
            const cart = await $.getJSON('/cart.js');
            const matching = (cart.items || []).find((item) => String(cartItemId) == String(item.id));
            if (!matching) continue;
            await $.ajax({
              type: 'POST', url: '/cart/change.js', dataType: 'json',
              data: { id: matching.key, properties: { __prescriptionFile: referenceName, __prescriptionType: 'Self' } },
            });
            succeeded++;
          } catch (err) {
            $form.append('<p class="error">An error occurred while processing your request. Please try again.</p>');
          }
        }
        if (processed === total) {
          if (succeeded > 0) window.location.href = '/checkout';
          else $btn.prop('disabled', false).css('cursor', '');
        }
      }
    } catch (err) {
      $btn.prop('disabled', false).css('cursor', '');
      console.error('Prescription submission failed:', err);
    }
  });

  $(function () { syncSingleRxFormToCurrentItem(); });
}
